export default __webpack_public_path__ + "static/media/webcam6.40131681.jfif";